import {
  GetFirmUsersRequest,
  GetFirmUsersResponse,
  CreateFirmUserRequest,
  CreateFirmUserResponse,
  UpdateFirmUserRequest,
} from "@shared/apiSchemas/support";
import { cmaBackendApi, TagTypes } from "../api";

const _support_firmUsersApi = cmaBackendApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * getFirmUsers
     */
    getFirmUsers: build.query<GetFirmUsersResponse, GetFirmUsersRequest>({
      query: ({ firmId, paginationQuery }) => {
        let params = new URLSearchParams();
        if (paginationQuery) {
          params.append("page", paginationQuery.page.toString());
          params.append("pageSize", paginationQuery.pageSize.toString());
          if (paginationQuery.sortBy) {
            params.append("sortBy", paginationQuery.sortBy);
          }
          if (paginationQuery.sortOrder) {
            params.append("sortOrder", paginationQuery.sortOrder);
          }
        }
        return {
          url: `/support/firms/${firmId}/users`,
          method: "GET",
          params,
        };
      },
      providesTags: (result, __, { firmId }) => [
        { type: TagTypes.Users, firmId },
        ...(result
          ? result.users.map((user) => ({
              type: TagTypes.Users,
              userId: user.id,
            }))
          : []),
      ],
    }),

    /**
     * createFirmUser
     */
    addNewFirmUser: build.mutation<
      CreateFirmUserResponse,
      CreateFirmUserRequest & { firmId: string }
    >({
      query: ({ firmId, ...createFirmRequest }) => ({
        url: `/support/firms/${firmId}/users`,
        method: "POST",
        data: createFirmRequest,
      }),
      invalidatesTags: (_, __, { firmId }) => [
        { type: TagTypes.Users, firmId },
        { type: TagTypes.Firms, firmId },
      ],
    }),

    /**
     * updateFirmUser
     */
    updateFirmUser: build.mutation<
      void,
      { firmId: string; userId: string; data: UpdateFirmUserRequest }
    >({
      query: ({ firmId, userId, data }) => ({
        url: `/support/firms/${firmId}/users/${userId}`,
        method: "PUT",
        data,
      }),
      invalidatesTags: (_, __, { firmId, userId }) => [
        { type: TagTypes.Users, firmId },
        { type: TagTypes.Users, userId },
      ],
    }),

    /**
     * deleteFirmUser
     */
    deleteFirmUser: build.mutation<void, { firmId: string; userId: string }>({
      query: ({ firmId, userId }) => ({
        url: `/support/firms/${firmId}/users/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, __, { firmId, userId }) => [
        { type: TagTypes.Users, firmId },
        { type: TagTypes.Users, userId },
        { type: TagTypes.Firms, firmId },
      ],
    }),
  }),
});

export const {
  useGetFirmUsersQuery,
  useLazyGetFirmUsersQuery,
  useAddNewFirmUserMutation,
  useUpdateFirmUserMutation,
  useDeleteFirmUserMutation,
} = _support_firmUsersApi;
